<template>
  <vx-card class="vx-card_full-height">
    <div :class="$style.head">
      <h4 class="mt-8 mr-2">Уведомления</h4>
      <NotifiesFilter :on-change="onChangeFilter" />
      <div :class="$style.actions">
        <vs-button
          class=""
          type="border"
          :to="{name: 'uc_notifies_config'}"
        >
          Автонастройки
        </vs-button>

        <vs-button
          class="ml-2"
          type="border"
          iconPack="feather"
          icon="icon-download"
          title="Экспортировать"
          @click="onExport"
        />

        <vs-button
          class="ml-2"
          type="border"
          iconPack="feather"
          icon="icon-plus"
          title="Добавить уведомление"
          :to="{name: 'uc_notifies_create'}"
        />
      </div>
    </div>

    <grid-infinite-scroll
      ref="table"
      :columns="columns"
      :getData="getData"
      :filterable="false"
      :sortable="false"
      :rowHeight="40"
    />
  </vx-card>
</template>

<script>
import NotifiesApartmentRenderer from "@/components/notifies/NotifiesApartmentRenderer";
import formatDate                from "@/client/helpers/formatDate";
import NotifiesFilter            from "@/components/notifies/NotifiesFilter";
import AgGridActions             from "@/components/common/AgGridActions";
import notifiesStatuses          from "@/dictionaries/notifiesStatuses";
import stringify                 from "qs/lib/stringify";

export default {
  name:       "Notifies",
  components: { NotifiesFilter },
  data() {
    return {
      templatesOptions: [],
      filters:          {},
    };
  },
  computed: {
    columns() {
      return [
        {
          headerName:  "№",
          field:       'notify_number',
          width:       80,
          sortable:    true,
          filter:      true,
          pinned:      'left',
          headerClass: this.$style.left,
          cellClass:   this.$style.left,
        },
        {
          headerName:   "Тип документа",
          field:        'type_id',
          width:        200,
          sortable:     true,
          filter:       'select',
          pinned:       'left',
          filterParams: { options: this.templatesOptions },
          headerClass:  this.$style.left,
          cellClass:    this.$style.left,
          valueGetter:  ( { data } ) => data.notify_name,
        },
        {
          headerName:   "Статус",
          field:        'status',
          width:        140,
          sortable:     true,
          filter:       'select',
          pinned:       'left',
          filterParams: { options: notifiesStatuses.selectOptions },
          headerClass:  this.$style.left,
          cellClass:    this.$style.left,
          valueGetter:  ( { data } ) => notifiesStatuses.dict[data.status].title,
        },
        {
          headerName:            "Номер помещения",
          field:                 'apart_number',
          minWidth:              140,
          sortable:              true,
          filter:                true,
          headerClass:           this.$style.left,
          cellClass:             this.$style.left,
          cellRendererFramework: NotifiesApartmentRenderer,
        },
        {
          headerName:  "Задолженность",
          field:       'sum',
          minWidth:    120,
          sortable:    true,
          filter:      false,
          headerClass: this.$style.right,
          cellClass:   this.$style.right,
        },
        {
          headerName:  "Дата создания",
          field:       'create_date',
          minWidth:    120,
          sortable:    true,
          filter:      false,
          headerClass: this.$style.left,
          cellClass:   this.$style.left,
          valueGetter: ( { data } ) => formatDate(data.create_date),
        },
        // {
        //   headerName:  "Оплатить до",
        //   field:       'date_debt_close',
        //   minWidth:    100,
        //   sortable:    true,
        //   filter:      false,
        //   headerClass: this.$style.left,
        //   cellClass:   this.$style.left,
        //   valueGetter: ( { data } ) => formatDate(data.date_debt_close),
        // },
        {
          headerName:  "Лицевой счет",
          field:       'account_number',
          minWidth:    140,
          sortable:    true,
          filter:      true,
          headerClass: this.$style.left,
          cellClass:   this.$style.left,
        },
        {
          headerName:  "ФИО Собственника",
          field:       'users_names',
          minWidth:    320,
          sortable:    false,
          filter:      true,
          headerClass: this.$style.left,
          cellClass:   this.$style.left,
        },
        {
          headerName:  "Внутренний комментарий",
          field:       'notify_comment',
          minWidth:    300,
          sortable:    false,
          filter:      true,
          headerClass: this.$style.left,
          cellClass:   this.$style.left,
        },
        {
          headerName: '',
          field:      'actions',
          filter:     false,
          sortable:   false,
          minWidth:   50,
          maxWidth:   50,
          editable:   false,
          pinned:     "right",
          // hide:                  !this.$can('rp.recalculation', 'write'),
          cellRendererFramework: AgGridActions,
          cellRendererParams:    ( { data } ) => {
            if (!data) return {};
            return {
              actions: [
                {
                  icon:   'icon-edit',
                  title:  'Изменить',
                  action: () => this.$modal.open({
                    size:           'sm',
                    title:          data.notify_name,
                    component:      () => import('@/components/notifies/NotifiesEditPopup'),
                    componentProps: { data },
                  }).result.then(() => {
                    this.resetData();
                  }),
                },
              ],
            };
          },
        },
      ];
    },

    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },
  },
  methods:  {
    loadTemplates() {
      this.$http.get('notify/templates', { params: { buildings_id: this.selectedHouseId } }).then(( { data } ) => {
        this.templatesOptions = data.map(t => ({
          value: t.id,
          label: t.notify_name,
        }));
      });
    },

    resetData() {
      const { table } = this.$refs;
      table && table.resetData();
    },

    getData( page, filters, orderBy ) {
      filters = JSON.parse(filters);
      const { apartmentsType, createDate, dateDebtClose, sum } = this.filters;
      if (typeof apartmentsType === 'number') filters.push(['type_apart', 'equals', apartmentsType]);
      if (createDate) {
        if (createDate.from) filters.push(['create_date', 'greaterThanOrEqual', formatDate(createDate.from, 'yyyy-MM-dd')]);
        if (createDate.to) filters.push(['create_date', 'lessThanOrEqual', formatDate(createDate.to, 'yyyy-MM-dd')]);
      }
      if (dateDebtClose) {
        if (dateDebtClose.from) filters.push(['date_debt_close', 'greaterThanOrEqual', formatDate(dateDebtClose.from, 'yyyy-MM-dd')]);
        if (dateDebtClose.to) filters.push(['date_debt_close', 'lessThanOrEqual', formatDate(dateDebtClose.to, 'yyyy-MM-dd')]);
      }
      if (sum) {
        if (sum.from) filters.push(['sum', 'greaterThanOrEqual', sum.from]);
        if (sum.to) filters.push(['sum', 'lessThanOrEqual', sum.to]);
      }

      return this.$http.get('notifies', {
        params:           {
          buildings_id: this.selectedHouseId,
          filters,
          order_by:     [orderBy],
        },
        paramsSerializer: ( params ) => stringify(params),
      }).then(( { data } ) => {
        return {
          response: { data },
          total:    data.length,
          data:     data,
        };
      });
    },

    onExport() {
      this.$refs.table.exportRows('Уведомления');
    },

    onChangeFilter( filter ) {
      this.filters = filter;
      this.resetData();
    },
  },
  mounted() {
    this.loadTemplates();
  },
  watch: {
    selectedHouseId() {
      this.resetData();
    },
  },
};
</script>

<style lang="scss" module>
.head {
  display: flex;
  align-items: flex-start;
  margin-bottom: 1em;
}

.actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  padding-left: .5em;
}

.left {
  :global(.ag-table-row-pined_bottom) &:global(.ag-cell-value) > span {
    justify-content: flex-start;
  }

  :global {
    .ag-cell-label-container .ag-header-cell-label,
    .ag-table-cell-value {
      //padding: 0 10px;
      justify-content: flex-start;
      text-align: left;

      .ag-header-cell-text {
        text-align: left;
      }
    }
  }
}

.right {
  :global {
    .ag-cell-label-container .ag-header-cell-label,
    .ag-table-cell-value {
      //padding: 0 10px;
      justify-content: flex-end;
      text-align: right;
      font-size: 1.1em;

      .ag-header-cell-text {
        text-align: right;
      }
    }

  }

  &:global(.ag-cell-value) > span {
    font-family: 'Droid Sans Mono', monospace;
    white-space: nowrap;
    justify-content: flex-end !important;
    //font-weight: bold;
    //-webkit-font-smoothing: antialiased;
  }

}
</style>
